import { MatchResult, SchoolEvent } from 'models/event';

export interface DisplayMatchResult {
   home: number | string;
   away: number | string;
   winnerTeamId?: string;
   resolution?: MatchResult['resolution'];
   suffix: string;
   isDraft: boolean;
}

export function getDisplayMatchResult(event: SchoolEvent): DisplayMatchResult | undefined {
   const match = event.matchResult;
   if (match?.regulation) {
      const suffix = match.resolution === 'SHOOTOUT' && match.shootout
         ? `(${match.shootout.home}–${match.shootout.away} pens)`
         : match.resolution === 'EXTRA_TIME' ? '(AET)'
         : match.resolution === 'WALKOVER' ? '(W/O)'
         : match.resolution === 'FORFEIT' ? '(forfeit)'
         : '';
      return {
         home: match.resolution === 'EXTRA_TIME' && match.extraTime ? match.extraTime.home : match.regulation.home,
         away: match.resolution === 'EXTRA_TIME' && match.extraTime ? match.extraTime.away : match.regulation.away,
         winnerTeamId: match.winnerTeamId,
         resolution: match.resolution,
         suffix,
         isDraft: event.resultPublication?.status === 'DRAFT'
      };
   }

   const teams = event.embeddedTeams || [];
   const scores = event.results?.teamScore || [];
   if (teams.length < 2 || !scores.length) return undefined;
   const value = (team: any) => {
      const score = scores.find(item => String(item.teamId) === String(team.id || team._id));
      return score?.richScore?.result ?? score?.score ?? '';
   };
   return {home: value(teams[0]), away: value(teams[1]), suffix: '', isDraft: false};
}
